const Docs2Screen = () => {
    window.location.replace('/docs/terms.html');
    return false;
};

export default Docs2Screen;